import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useBrandStore } from "@faire/retailer-visitor-shared/stores/domain/BrandStore";
import { logError } from "@faire/web--source/common/logging";
import { Storage } from "@faire/web--source/common/Storage";
import postProspectiveBrand from "@faire/web-api--source/api/brand-lead/prospective-brand/post";
import getBrandSalesforceOwner from "@faire/web-api--source/api/brand/brandToken/salesforce-owner/get";
import brandApplication from "@faire/web-api--source/routes/apply";
import qs from "qs";
import { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { getSettingSalesforceFallbackSalesRepCalendarUrl } from "@faire/retailer/settings/getSettingSalesforceFallbackSalesRepCalendarUrl";
import { MakerApplicationStages } from "@faire/retailer/views/apply/MakerApplication/MakerSignUpState";
import { IS_PERSONALIZED_LANDING_PAGE_BRAND_TOKEN } from "../const";
import { useBrandsLandingPageStore } from "../stores/BrandsLandingPageContextStore";
export var useBrandsLandingPageState = function() {
    var history = useHistory();
    var _useBrandsLandingPageStore = _sliced_to_array(useBrandsLandingPageStore([
        "brandToken",
        "existingEmail",
        "showBanner",
        "email",
        "isLoading",
        "salesforceOwnerUrl",
        "isMarketSectionVisible",
        "makerSignUpState"
    ]), 2), _useBrandsLandingPageStore_ = _useBrandsLandingPageStore[0], brandToken = _useBrandsLandingPageStore_.brandToken, existingEmail = _useBrandsLandingPageStore_.existingEmail, showBanner = _useBrandsLandingPageStore_.showBanner, email = _useBrandsLandingPageStore_.email, isLoading = _useBrandsLandingPageStore_.isLoading, salesforceOwnerUrl = _useBrandsLandingPageStore_.salesforceOwnerUrl, isMarketSectionVisible = _useBrandsLandingPageStore_.isMarketSectionVisible, makerSignUpState = _useBrandsLandingPageStore_.makerSignUpState, setBrandsLandingPageStore = _useBrandsLandingPageStore[1];
    var _useBrandStore = useBrandStore([
        "prefetchedFullBrand",
        "getBrand"
    ]), prefetchedFullBrand = _useBrandStore.prefetchedFullBrand, getBrand = _useBrandStore.getBrand;
    var _useState = _sliced_to_array(useState(prefetchedFullBrand), 2), brand = _useState[0], setBrand = _useState[1];
    var preSavedBrandToken = Storage.local.getItem(IS_PERSONALIZED_LANDING_PAGE_BRAND_TOKEN);
    var fetchCalenderUrl = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(brandToken) {
            var _res_account_owner, res, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            getBrandSalesforceOwner(brandToken)
                        ];
                    case 1:
                        res = _state.sent();
                        setBrandsLandingPageStore({
                            salesforceOwnerUrl: (_res_account_owner = res.account_owner) === null || _res_account_owner === void 0 ? void 0 : _res_account_owner.calendar_url
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        logError(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(brandToken) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setBrandsLandingPageStore
    ]);
    var loadBrand = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var activeOrSavedBrandToken, brandData, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    activeOrSavedBrandToken = brandToken !== null && brandToken !== void 0 ? brandToken : preSavedBrandToken;
                    if (!activeOrSavedBrandToken || brand) {
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        6
                    ]);
                    setBrandsLandingPageStore({
                        isLoading: true
                    });
                    return [
                        4,
                        fetchCalenderUrl(activeOrSavedBrandToken)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        getBrand(activeOrSavedBrandToken)
                    ];
                case 3:
                    brandData = _state.sent();
                    setBrand(brandData);
                    return [
                        3,
                        6
                    ];
                case 4:
                    error = _state.sent();
                    logError(error);
                    return [
                        3,
                        6
                    ];
                case 5:
                    setBrandsLandingPageStore({
                        isLoading: false
                    });
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), [
        brand,
        brandToken,
        fetchCalenderUrl,
        getBrand,
        preSavedBrandToken,
        setBrandsLandingPageStore
    ]);
    var storePersonalizedLandingPage = useCallback(function() {
        if (brandToken && brand) {
            Storage.local.setItem(IS_PERSONALIZED_LANDING_PAGE_BRAND_TOKEN, brandToken);
        }
    }, [
        brandToken,
        brand
    ]);
    var init = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        loadBrand()
                    ];
                case 1:
                    _state.sent();
                    storePersonalizedLandingPage();
                    return [
                        2
                    ];
            }
        });
    }), [
        loadBrand,
        storePersonalizedLandingPage
    ]);
    var _ref;
    var emailAddress = (_ref = email !== null && email !== void 0 ? email : makerSignUpState === null || makerSignUpState === void 0 ? void 0 : makerSignUpState.email) !== null && _ref !== void 0 ? _ref : existingEmail;
    var handleEmailChange = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setBrandsLandingPageStore({
            email: e.target.value
        });
    };
    var calendlyLink = salesforceOwnerUrl !== null && salesforceOwnerUrl !== void 0 ? salesforceOwnerUrl : getSettingSalesforceFallbackSalesRepCalendarUrl();
    var isValidBrandToken = !!brandToken && !!brand;
    var isPersonalized = !!preSavedBrandToken || isValidBrandToken;
    var isR2BorB2B = !!makerSignUpState;
    var applyEnteredEmail = function() {
        if (!emailAddress) {
            return;
        }
        if (makerSignUpState) {
            makerSignUpState.setEmailAddress(emailAddress);
            makerSignUpState.trackInviteClicked(emailAddress);
        }
        postProspectiveBrand({
            email_address: emailAddress
        });
        // Add the entered email to the query params to preserve information if they refresh
        history.replace(_object_spread_props(_object_spread({}, history.location), {
            search: qs.stringify(_object_spread_props(_object_spread({}, qs.parse(history.location.search)), {
                email_address: emailAddress
            }))
        }));
    };
    var goToForm = function() {
        applyEnteredEmail();
        if (makerSignUpState) {
            makerSignUpState.applicationStage = MakerApplicationStages.FORM;
        } else {
            var brandApplicationPath = brandApplication(emailAddress ? {
                email_address: emailAddress
            } : undefined);
            history.push(brandApplicationPath);
        }
    };
    var setMakerSignUpState = function(value) {
        setBrandsLandingPageStore({
            makerSignUpState: value
        });
    };
    var setIsMarketSectionVisible = function(value) {
        setBrandsLandingPageStore({
            isMarketSectionVisible: value
        });
    };
    var setBanner = function(value) {
        setBrandsLandingPageStore({
            showBanner: value
        });
    };
    return {
        showBanner: showBanner,
        email: email,
        brand: brand,
        isLoading: isLoading,
        salesforceOwnerUrl: salesforceOwnerUrl,
        isMarketSectionVisible: isMarketSectionVisible,
        makerSignUpState: makerSignUpState,
        setMakerSignUpState: setMakerSignUpState,
        handleEmailChange: handleEmailChange,
        emailAddress: emailAddress,
        calendlyLink: calendlyLink,
        init: init,
        isValidBrandToken: isValidBrandToken,
        isPersonalized: isPersonalized,
        isR2BorB2B: isR2BorB2B,
        goToForm: goToForm,
        setIsMarketSectionVisible: setIsMarketSectionVisible,
        setBanner: setBanner
    };
};
